var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-field",attrs:{"id":"searchFieldDiv"}},[_c('InputField',{attrs:{"placeholder":_vm.placeholder,"value":_vm.value},on:{"change":_vm.valueChanged}},[_c('SearchIcon')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }